import { apiClient } from '@/lib/apiClient';

const get = async (path, options) => {
  const { data, error } = await apiClient.GET(path, options);
  if (error) throw error;
  return data;
};

export const irancharsouqAdminApi = {
  getProfile: () => get('/api/v1/irancharsouq_admin/profile'),
  updateProfile: async (body) => {
    const { data, error } = await apiClient.PATCH(
      '/api/v1/irancharsouq_admin/profile',
      { body },
    );
    if (error) throw error;
    return data;
  },
  getProducts: (params) => get('/api/v1/irancharsouq_admin/products', { params: { query: params } }),
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const { data, error } = await apiClient.POST('/api/v1/irancharsouq_admin/products/upload-image', {
      body: formData,
    });
    if (error) throw error;
    return data;
  },
  createProduct: async (body) => {
    const { data, error } = await apiClient.POST(
      '/api/v1/irancharsouq_admin/products',
      { body },
    );
    if (error) throw error;
    return data;
  },
  updateProduct: async (productId, body) => {
    const { data, error } = await apiClient.PATCH(
      '/api/v1/irancharsouq_admin/products/{product_id}',
      { params: { path: { product_id: productId } }, body },
    );
    if (error) throw error;
    return data;
  },
  deleteProduct: async (productId) => {
    const { error } = await apiClient.DELETE(
      '/api/v1/irancharsouq_admin/products/{product_id}',
      { params: { path: { product_id: productId } } },
    );
    if (error) throw error;
  },
  getOrders: (params) => get('/api/v1/irancharsouq_admin/orders', { params: { query: params } }),
  getOrder: (orderId) => get('/api/v1/irancharsouq_admin/orders/{order_id}', {
    params: { path: { order_id: orderId } },
  }),
  respondToOrder: async (orderId, status) => {
    const { data, error } = await apiClient.PATCH(
      '/api/v1/irancharsouq_admin/orders/{order_id}/respond',
      { params: { path: { order_id: orderId } }, body: { status } },
    );
    if (error) throw error;
    return data;
  },
  shipOrder: async (orderId, trackingNumber) => {
    const { data, error } = await apiClient.PATCH(
      '/api/v1/irancharsouq_admin/orders/{order_id}/ship',
      { params: { path: { order_id: orderId } }, body: { tracking_number: trackingNumber } },
    );
    if (error) throw error;
    return data;
  },
  deliverOrder: async (orderId) => {
    const { data, error } = await apiClient.PATCH(
      '/api/v1/irancharsouq_admin/orders/{order_id}/deliver',
      { params: { path: { order_id: orderId } } },
    );
    if (error) throw error;
    return data;
  },
  pack: async (orderId, body = {}) => {
    const { data, error } = await apiClient.PATCH(
      '/api/v1/irancharsouq_admin/orders/{order_id}/pack',
      { params: { path: { order_id: orderId } }, body },
    );
    if (error) throw error;
    return data;
  },
  handover: async (orderId, body) => {
    const { data, error } = await apiClient.PATCH(
      '/api/v1/irancharsouq_admin/orders/{order_id}/handover',
      { params: { path: { order_id: orderId } }, body },
    );
    if (error) throw error;
    return data;
  },
};
